<template>
    <span>{{ value }}</span>
</template>

<script>
export default {
    name: 'formatPrice',
    props: ['value', 'format']
};
</script>
